export const ELEMENT_INFO = {
  H: { name: 'Hydrogen', number: 1, mass: 1.008 },
  He: { name: 'Helium', number: 2, mass: 4.003 },
  Li: { name: 'Lithium', number: 3, mass: 6.941 },
  Be: { name: 'Beryllium', number: 4, mass: 9.012 },
  B: { name: 'Boron', number: 5, mass: 10.811 },
  C: { name: 'Carbon', number: 6, mass: 12.011 },
  N: { name: 'Nitrogen', number: 7, mass: 14.007 },
  O: { name: 'Oxygen', number: 8, mass: 15.999 },
  F: { name: 'Fluorine', number: 9, mass: 18.998 },
  Ne: { name: 'Neon', number: 10, mass: 20.18 },
  Na: { name: 'Sodium', number: 11, mass: 22.99 },
  Mg: { name: 'Magnesium', number: 12, mass: 24.305 },
  Al: { name: 'Aluminum', number: 13, mass: 26.982 },
  Si: { name: 'Silicon', number: 14, mass: 28.086 },
  P: { name: 'Phosphorus', number: 15, mass: 30.974 },
  S: { name: 'Sulfur', number: 16, mass: 32.065 },
  Cl: { name: 'Chlorine', number: 17, mass: 35.453 },
  Ar: { name: 'Argon', number: 18, mass: 39.948 },
  K: { name: 'Potassium', number: 19, mass: 39.098 },
  Ca: { name: 'Calcium', number: 20, mass: 40.078 },
  Sc: { name: 'Scandium', number: 21, mass: 44.956 },
  Ti: { name: 'Titanium', number: 22, mass: 47.867 },
  V: { name: 'Vanadium', number: 23, mass: 50.942 },
  Cr: { name: 'Chromium', number: 24, mass: 51.996 },
  Mn: { name: 'Manganese', number: 25, mass: 54.938 },
  Fe: { name: 'Iron', number: 26, mass: 55.845 },
  Co: { name: 'Cobalt', number: 27, mass: 58.933 },
  Ni: { name: 'Nickel', number: 28, mass: 58.693 },
  Cu: { name: 'Copper', number: 29, mass: 63.546 },
  Zn: { name: 'Zinc', number: 30, mass: 65.38 },
  Ga: { name: 'Gallium', number: 31, mass: 69.723 },
  Ge: { name: 'Germanium', number: 32, mass: 72.64 },
  As: { name: 'Arsenic', number: 33, mass: 74.922 },
  Se: { name: 'Selenium', number: 34, mass: 78.96 },
  Br: { name: 'Bromine', number: 35, mass: 79.904 },
  Kr: { name: 'Krypton', number: 36, mass: 83.798 },
  Rb: { name: 'Rubidium', number: 37, mass: 85.468 },
  Sr: { name: 'Strontium', number: 38, mass: 87.62 },
  Y: { name: 'Yttrium', number: 39, mass: 88.906 },
  Zr: { name: 'Zirconium', number: 40, mass: 91.224 },
  Nb: { name: 'Niobium', number: 41, mass: 92.906 },
  Mo: { name: 'Molybdenum', number: 42, mass: 95.96 },
  Tc: { name: 'Technetium', number: 43, mass: 98.0 },
  Ru: { name: 'Ruthenium', number: 44, mass: 101.07 },
  Rh: { name: 'Rhodium', number: 45, mass: 102.906 },
  Pd: { name: 'Palladium', number: 46, mass: 106.42 },
  Ag: { name: 'Silver', number: 47, mass: 107.868 },
  Cd: { name: 'Cadmium', number: 48, mass: 112.411 },
  In: { name: 'Indium', number: 49, mass: 114.818 },
  Sn: { name: 'Tin', number: 50, mass: 118.71 },
  Sb: { name: 'Antimony', number: 51, mass: 121.76 },
  Te: { name: 'Tellurium', number: 52, mass: 127.6 },
  I: { name: 'Iodine', number: 53, mass: 126.904 },
  Xe: { name: 'Xenon', number: 54, mass: 131.293 },
  Cs: { name: 'Cesium', number: 55, mass: 132.905 },
  Ba: { name: 'Barium', number: 56, mass: 137.327 },
  La: { name: 'Lanthanum', number: 57, mass: 138.905 },
  Ce: { name: 'Cerium', number: 58, mass: 140.116 },
  Pr: { name: 'Praseodymium', number: 59, mass: 140.908 },
  Nd: { name: 'Neodymium', number: 60, mass: 144.242 },
  Pm: { name: 'Promethium', number: 61, mass: 145.0 },
  Sm: { name: 'Samarium', number: 62, mass: 150.36 },
  Eu: { name: 'Europium', number: 63, mass: 151.964 },
  Gd: { name: 'Gadolinium', number: 64, mass: 157.25 },
  Tb: { name: 'Terbium', number: 65, mass: 158.925 },
  Dy: { name: 'Dysprosium', number: 66, mass: 162.5 },
  Ho: { name: 'Holmium', number: 67, mass: 164.93 },
  Er: { name: 'Erbium', number: 68, mass: 167.259 },
  Tm: { name: 'Thulium', number: 69, mass: 168.934 },
  Yb: { name: 'Ytterbium', number: 70, mass: 173.054 },
  Lu: { name: 'Lutetium', number: 71, mass: 174.967 },
  Hf: { name: 'Hafnium', number: 72, mass: 178.49 },
  Ta: { name: 'Tantalum', number: 73, mass: 180.948 },
  W: { name: 'Tungsten', number: 74, mass: 183.84 },
  Re: { name: 'Rhenium', number: 75, mass: 186.207 },
  Os: { name: 'Osmium', number: 76, mass: 190.23 },
  Ir: { name: 'Iridium', number: 77, mass: 192.217 },
  Pt: { name: 'Platinum', number: 78, mass: 195.084 },
  Au: { name: 'Gold', number: 79, mass: 196.967 },
  Hg: { name: 'Mercury', number: 80, mass: 200.59 },
  Tl: { name: 'Thallium', number: 81, mass: 204.383 },
  Pb: { name: 'Lead', number: 82, mass: 207.2 },
  Bi: { name: 'Bismuth', number: 83, mass: 208.98 },
  Po: { name: 'Polonium', number: 84, mass: 209.0 },
  At: { name: 'Astatine', number: 85, mass: 210.0 },
  Rn: { name: 'Radon', number: 86, mass: 222.0 },
  Fr: { name: 'Francium', number: 87, mass: 223.0 },
  Ra: { name: 'Radium', number: 88, mass: 226.0 },
  Ac: { name: 'Actinium', number: 89, mass: 227.0 },
  Th: { name: 'Thorium', number: 90, mass: 232.038 },
  Pa: { name: 'Protactinium', number: 91, mass: 231.036 },
  U: { name: 'Uranium', number: 92, mass: 238.029 },
  Np: { name: 'Neptunium', number: 93, mass: 237.0 },
  Pu: { name: 'Plutonium', number: 94, mass: 244.0 },
  Am: { name: 'Americium', number: 95, mass: 243.0 },
  Cm: { name: 'Curium', number: 96, mass: 247.0 },
  Bk: { name: 'Berkelium', number: 97, mass: 247.0 },
  Cf: { name: 'Californium', number: 98, mass: 251.0 },
  Es: { name: 'Einsteinium', number: 99, mass: 252.0 },
  Fm: { name: 'Fermium', number: 100, mass: 257.0 },
  Md: { name: 'Mendelevium', number: 101, mass: 258.0 },
  No: { name: 'Nobelium', number: 102, mass: 259.0 },
  Lr: { name: 'Lawrencium', number: 103, mass: 262.0 },
};

export const PERIODIC_TABLE = [
  ['H', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'He'],
  ['Li', 'Be', '', '', '', '', '', '', '', '', '', '', 'B', 'C', 'N', 'O', 'F', 'Ne'],
  ['Na', 'Mg', '', '', '', '', '', '', '', '', '', '', 'Al', 'Si', 'P', 'S', 'Cl', 'Ar'],
  ['K', 'Ca', 'Sc', 'Ti', 'V', 'Cr', 'Mn', 'Fe', 'Co', 'Ni', 'Cu', 'Zn', 'Ga', 'Ge', 'As', 'Se', 'Br', 'Kr'],
  ['Rb', 'Sr', 'Y', 'Zr', 'Nb', 'Mo', 'Tc', 'Ru', 'Rh', 'Pd', 'Ag', 'Cd', 'In', 'Sn', 'Sb', 'Te', 'I', 'Xe'],
  ['Cs', 'Ba', 'La', 'Hf', 'Ta', 'W', 'Re', 'Os', 'Ir', 'Pt', 'Au', 'Hg', 'Tl', 'Pb', 'Bi', 'Po', 'At', 'Rn'],
  ['Fr', 'Ra', 'Ac', 'Rf', 'Db', 'Sg', 'Bh', 'Hs', 'Mt', 'Ds', 'Rg', 'Cn', 'Nh', 'Fl', 'Mc', 'Lv', 'Ts', 'Og'],
  ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
  ['', '', 'Ce', 'Pr', 'Nd', 'Pm', 'Sm', 'Eu', 'Gd', 'Tb', 'Dy', 'Ho', 'Er', 'Tm', 'Yb', 'Lu', '', ''],
  ['', '', 'Th', 'Pa', 'U', 'Np', 'Pu', 'Am', 'Cm', 'Bk', 'Cf', 'Es', 'Fm', 'Md', 'No', 'Lr', '', ''],
];
